import classNames from "classnames";

const MergeCheckbox = ({
  isSelected,
  disabled,
  onClick,
  css = "pl-1 pr-1 text-dark",
}) => {
  return (
    <i
      className={classNames(
        css,
        `mdi mdi-checkbox-${isSelected ? "marked" : "blank-outline"}`
      )}
      style={{
        fontSize: 24,
        cursor: disabled ? "not-allowed" : "pointer",
      }}
      onClick={disabled ? null : onClick}
    />
  );
};

export default MergeCheckbox;
